import { render } from "./selectTemporada.vue?vue&type=template&id=48aa5141"
import script from "./selectTemporada.vue?vue&type=script&lang=ts"
export * from "./selectTemporada.vue?vue&type=script&lang=ts"
script.render = render

export default script